import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AssessmentPromoComponent } from './assessment-promo/assessment-promo.component';
import { DashboarditemComponent } from './dashboarditem/dashboarditem.component';
import { TangoTrainingComponent } from './tango-Training/tango-Training.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SaleAdvertisementComponent } from './sale-advertisement/sale-advertisement.component';

@Component({
  selector: 'app-asklearnshare',
  standalone: true,
  imports: [DashboarditemComponent, AssessmentPromoComponent, TangoTrainingComponent, NgbModule, SaleAdvertisementComponent],
  templateUrl: './asklearnshare.component.html',
  styleUrls: ['./asklearnshare.component.scss'],
  encapsulation: ViewEncapsulation.None, /*This enables the carousel-indicators styles*/
})
export class AsklearnshareComponent implements OnInit {
  title: string = "";
  constructor() { }

  ngOnInit(): void {
    this.title="What's New ?"
  }
  onSlide(ev: any) {
    if (ev.current == 'ngb-slide-2') 
      this.title = "What's New ? ";
    else 
      this.title = "What's New ? ";
  }
}
